import { FC } from 'react';
import './animalListItemSkeleton.scss';

const AnimalListItemSkeleton: FC = (): JSX.Element => {
  return (
    <div className="animal-list-item-skeleton">
      <div className="skeleton-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-main-info">
          <div className="skeleton-title"></div>
          <div className="skeleton-details">
            <div className="skeleton-text"></div>
            <div className="skeleton-text"></div>
            <div className="skeleton-text"></div>
            <div className="skeleton-text"></div>
          </div>
        </div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  );
};

export default AnimalListItemSkeleton;
